/* eslint-disable no-plusplus */

// Function to create a data URL from base64 data for displaying images
export const createDataUrl = (base64Data: string, fileType: string): string =>
 `data:${fileType};base64,${base64Data}`;

// Function to trigger download of base64 data
export const downloadBase64File = (
 base64Data: string,
 fileName: string | number,
 fileType: string,
 extension: string,
) => {
 // Convert base64 string to a Blob
 const byteCharacters = atob(base64Data);
 const byteNumbers = new Array(byteCharacters.length);
 for (let i = 0; i < byteCharacters.length; i++) {
  byteNumbers[i] = byteCharacters.charCodeAt(i);
 }
 const byteArray = new Uint8Array(byteNumbers);
 const blob = new Blob([byteArray], { type: fileType });

 // Create a temporary anchor element and trigger download
 const link = document.createElement('a');
 link.href = URL.createObjectURL(blob);
 link.download = `${fileName}${extension ? '.' + extension : ''}`;
 document.body.appendChild(link);
 link.click();
 document.body.removeChild(link);
};
